import api from "@/services/http/api";
import apiAuth from "@/services/http/apiAuth";

export async function listarSiteSettings() {
  const res = await api.get("/site-settings");
  return res.data || { items: [] };
}

export async function obtenerSiteSettingsMap() {
  const { items = [] } = await listarSiteSettings();
  return items.reduce((acc, item) => {
    acc[item.key] = item.value || "";
    return acc;
  }, {});
}

export async function actualizarSiteSetting(key, payload) {
  const res = await apiAuth.put(
    `/site-settings/${encodeURIComponent(key)}`,
    payload,
  );
  return res.data;
}
